import API from 'API';

export const findSbsOutcomeById = (processOutcomeId) =>
  API.find(`processOutcomes/${processOutcomeId}`);

export const saveSbsProcessOutcome = async (processOutcome) =>
  API.save('processOutcomes/', processOutcome);

export const findProcessOutcomeBySbsId = (sbsId) =>
  API.find(`sbss/${sbsId}/processOutcomes`);
